import classNames from "classnames";

import styles from "./form.module.css";

const Form = ({ children, modal, noGap, ...rest }) => {
  return (
    <form
      className={classNames(styles.form, {
        [styles.modal]: modal,
        [styles.noGap]: noGap,
      })}
      {...rest}
    >
      {children}
    </form>
  );
};

export default Form;
